<template>
  <div>
    <div class="add_form_modal_wrapper">
      <div class="add_form_modal__containers">
        <div class="add-block-title d-flex justify-content-between align-items-center px-3 py-2">
          <h4 class="my-0">{{ $t("navigations.create form") }}</h4>
          <div class="tooltip-wrapper pointer" @click.prevent="$emit('closeModal')"
            style="float: right; cursor: pointer;">
            <i class="fa fa-times cursor-pointer"></i>
            <span class="custom-tooltip closetooltipposition">Close</span>
          </div>
        </div>
        <div class="row w-100 mx-auto">

          <div class="col-lg-6 mt-3">
            <label for="form-name">{{$t("navigations.form name")}}<sup><i class="fa fa-asterisk required"></i></sup>
            </label>
            <input type="text" maxlength="1000" class="form-control mb-3" id="form-name" v-model="formName"
              @input="errors.formName = false" placeholder="" aria-label="Form name" aria-describedby="form name">
            <span class="text-danger" v-if="errors.formName">
              {{ errors.formNameMessage }}
            </span>
          </div>
          <div class="col-lg-6 mt-3">
            <label for="crf-type-id">{{$t("navigations.crf type id")}}
            </label>
            <input type="text" maxlength="1000" class="form-control mb-3" id="crf-type-id" v-model="formData.crfTypeId"
              @input="errors.crfTypeId = false" placeholder="" aria-label="CRF type ID" aria-describedby="crf type id">
          </div>

          <div class="col-lg-4 mt-3">
            <label for="domain-code">{{ $t("navigations.domain code") }}
            </label>
            <input type="text" maxlength="1000" class="form-control mb-3" id="domain-code" v-model="formData.domainCode"
              placeholder="" aria-label="Domain code" aria-describedby="domain code">
          </div>
          <div class="col-lg-4 mt-3">
            <label for="form-oid">{{ $t("navigations.form oid") }}
            </label>
            <input type="text" class="form-control mb-3" id="form-oid" :value="formOID"
              placeholder="" aria-label="Form OID" aria-describedby="form oid">
          </div>
          <div class="col-lg-4 mt-3">
            <label for="cdash-version">{{ $t("navigations.cdash version") }}
            </label>
            <input type="text" maxlength="1000" class="form-control mb-3" id="cdash-version"
              v-model="formData.cdashVersion" placeholder="" aria-label="CDASH version"
              aria-describedby="cdash version">
          </div>

          <div class="col-lg-4 mt-3">
            <label for="sdtm-version">{{ $t("navigations.sdtm version") }}
            </label>
            <input type="text" maxlength="1000" class="form-control mb-3" id="sdtm-version"
              v-model="formData.sdtmVersion" placeholder="" aria-label="SDTM version" aria-describedby="sdtm version">
          </div>
          <div class="col-lg-4 mt-3">
            <label for="therapeutic-area">
              {{ $t("navigations.therapeutic area") }}
            </label>
            <select class="form-select mb-3" id="therapeutic-area" v-model="formData.therapeuticAreaId">
              <option disabled value="">{{ $t("navigations.select") }}</option>
              <option v-for="area in therapeuticAreas" :key="area.id" :value="area.id">
                {{ area.name }}
              </option>
            </select>
          </div>
          <div class="col-lg-4 mt-3">
            <label for="form-category">
              {{ $t("navigations.form category") }}
            </label>
            <select class="form-select mb-3" id="form-category" v-model="formData.formCategoryId">
              <option disabled value="">{{ $t("navigations.select") }}</option>
              <option v-for="category in formCategories" :key="category.id" :value="category.id">
                {{ category.formCategory }}
              </option>
            </select>
          </div>

          <div class="col-lg-12 py-3">
            <button type="button" class="btn add_btn d-flex mx-auto py-0" @click.prevent="createForm()">
               <span v-if="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-else>{{$t("navigations.submit") }}</span></button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script src="./createForm.js"></script>

<style scoped>
.tooltip-wrapper {
  position: relative;
}
.custom-tooltip-popups {
  position: absolute;
  top: 100%;
  transform: translateX(-80%);
  white-space: nowrap;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  z-index: 1000;
}
.add_form_modal_wrapper {
  position: absolute;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  transition: all .3s ease-in-out;
  overflow: hidden;
  z-index: 3000;
  padding-top: 100px;
}
.add_form_modal__containers {
  width: min(700px, 92%);
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}
.add-block-title {
  color: #ffffff;
  background-color: #768DD3;
}
.add_btn {
  color: #ffffff;
  background-color: #768DD3;
}
.add_btn:is(:hover, :focus, :active) {
  background-color: #768DD3;
}
.text-danger {
  font-size: 0.875rem;
}
</style>